import { routesName, useGetAuthorityFindRoles, useNavigation } from "core";
import React,{ memo } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Detail } from "../../templates";

const RoleDetail = memo(() => {
  const {_navigateWithParams}=useNavigation()
  const { i18n } = useTranslation();
  const { id } = useParams();
  
  const { data,isFetching } = useGetAuthorityFindRoles({pageNumber:"1",pageSize:"1",roleName:`${id}`});
  
  return (
    <>
      <Detail
        isLoading={isFetching}
        title={i18n.t("roleDetail")}
        data={data?.data?.roles}
        onClick={() => {
          _navigateWithParams(routesName.EDITROLE, {
            id: id,
          });
        }}
      />
    </>
  );
});
export { RoleDetail };
